import React, { useRef } from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Accordion, Panel } from "~/components/Accordion/Accordion"
import { Button } from "~/components/Button/Button"
import { Card } from "~/components/Card/Card"
import { ContentPopupInvest } from "~/components/GrowBusiness/components/ContentPopupInvest/ContentPopupInvest"
import { Heading } from "~/components/Heading/Heading"
import { PopupWrapper } from "~/components/Popup/Popup"
import { Raw } from "~/components/raw"
import { scrollIntoView } from "~/helpers/scrollIntoView"

import { Anchors } from "./components/Anchors/Anchors"
import styles from "./index.module.css"

const getQuestionInvestSuggestId = (): string => {
  if (process.env.APP_PLACEMENT === "test") {
    return "71146" // id - аккордеон с вопросом об инвестиционном предложении на тесте
  } else {
    return "48210" // id - аккордеон с вопросом об инвестиционном предложении в проде
  }
}

export const Content: React.FC = () => {
  const { t } = useTranslation()
  const accordionEl = useRef<HTMLDivElement[]>([])
  const { title, description, faqItems } = useApiContext("/faq/info")
  const anchors = faqItems.map(({ heading }) => heading)

  const onAnchorClick = (index: number): void => {
    scrollIntoView(accordionEl.current[index])
  }

  return (
    <div className={styles.Wrapper}>
      <PopupWrapper
        button={<div className={styles.FixedAnchors} />}
        content={({ closeHandler }) => (
          <Anchors
            anchors={anchors}
            onClick={(index) => {
              closeHandler()
              setTimeout(() => onAnchorClick(index), 350)
            }}
          />
        )}
      />

      <div className={styles.ColLeft}>
        <div className={styles.Head}>
          <Heading className={styles.Title} like="h1">
            <Raw html={title} />
          </Heading>

          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>

        {faqItems.map(({ heading, list, id: faqItemId }, i) => (
          <div
            key={heading}
            ref={(el: HTMLDivElement) => (accordionEl.current[i] = el)}
            className={styles.Items}
          >
            <Heading className={styles.AccordionHeading} like="h2">
              <Raw html={heading} />
            </Heading>

            <Accordion>
              {list.map(({ id, question, answer }) => (
                <Panel key={id} id={id} question={question}>
                  <Raw html={answer} />

                  {faqItemId === "284" && // faqItemId - раздела в faq "Каналы связи с АФК «Система»"
                    id === getQuestionInvestSuggestId() && (
                      <>
                        <br />
                        <PopupWrapper
                          button={
                            <Button className={styles.SuggestButton} view="rounded">
                              <Raw html={t("GrowBusiness.Buttons.suggest")} />
                            </Button>
                          }
                          content={() => <ContentPopupInvest type="suggest" />}
                        />
                      </>
                    )}
                </Panel>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
      <div className={styles.ColRight}>
        <Card className={styles.Anchors}>
          <Anchors anchors={anchors} onClick={onAnchorClick} />
        </Card>
      </div>
    </div>
  )
}
